import { useMemo } from 'react';
import ExpansionItem from './ExpanstionItem';
import { FormattedStep } from './useStepIndicator';

export interface StepIndicatorExpansionsProps {
  expansions: Omit<
    FormattedStep,
    'expand' | 'expansions' | 'number' | 'final'
  >[];
  active: boolean;
  isLoading: boolean;
}

const StepIndicatorExpansions: React.FunctionComponent<StepIndicatorExpansionsProps> =
  function ({ expansions, active, isLoading }) {
    const height = useMemo(() => (active ? 'auto' : '0px'), [active]);

    return (
      <div className="flex flex-col overflow-hidden" style={{ height }}>
        <div className="flex flex-col">
          {expansions.map((expansion) => (
            <ExpansionItem
              {...expansion}
              isLoading={isLoading}
              key={expansion.text}
            />
          ))}
        </div>
      </div>
    );
  };

export default StepIndicatorExpansions;
